import { BaseReducer } from '@hobs/utils/baseReducer';

class Loading extends BaseReducer {
  static defaultState = {};
  constructor() {
    super(Loading.defaultState);
  }

  reducer(state, action) {
    state = state || this.defaultState;
    const matches = /(.*)\/(Request|Success|Failure)/.exec(action.type);
    if (!matches) {
      return state;
    }
    const [, requestName, requestState] = matches;
    return {
      ...state,
      [requestName]: requestState === 'Request'
    };
  }
}

const reducer = new Loading().reducer;
export { reducer as loadingReducer };
